import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { IReturnChangesWidgetEditForm, checkIfFieldDisabled, deepCopy, defaultFieldsForm, formWidget_fieldOptions, formwidget_buttonStyleDefault, languagesList, makeid, widgetEditMode } from 'na-lib';
import { validColorValidator } from 'src/app/validators/color.validator';
import { SettingsService } from 'src/app/service/settings.service';
import { FormEditFieldDialogComponent } from '../../editWidgets/form-edit-field-dialog/form-edit-field-dialog.component';
import { TaskTemplateEditSectionDialogComponent } from 'src/app/worktask/worktask-template-edit-section-dialog/worktask-template-edit-section-dialog.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-form-edit-form',
    templateUrl: './form-edit-form.component.html',
    styleUrl: './form-edit-form.component.css',
    standalone: false
})

export class FormEditFormComponent {
  @Input() data:widgetEditMode;//widgetTranslationModeData
  @Output() returnChanges = new EventEmitter<IReturnChangesWidgetEditForm>();
  @Output() formChange = new EventEmitter<FormGroup>();

  formEditForm!:FormGroup
  formData:any
  oldData:any
  widgetNumber:any
  passId:any
  sectionsEdit:any =[]
  panelOpenState = false
  workflows:any

  allIdsSections:any =[]
  allKeysSection:any=[]
  sectionsForm!:FormGroup
  submitButtonStyleForm!:FormGroup

  addedFields:any = 0
  duplicateKeys = false
  duplicatedKeyNumber=0

  invalid_foregroundColor = false
  invalid_borderColor = false
  invalid_backgroundColor = false
  contextLicenseFree:any = false

  colorPalette:any=[]

  buttonStyleDefault:any = formwidget_buttonStyleDefault
  languagesList = languagesList
  defaultLanguage:string
  userHasBetaWidgetRole = false
  fieldOptions = formWidget_fieldOptions

  translationModeOriginal = false
  private destroy$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private settingsService:SettingsService
  ){  }

  ngOnInit():void{
    const contextId = this.settingsService.contextId$;

    this.settingsService.getWorkflowTemplates(contextId).pipe(takeUntil(this.destroy$)).subscribe(workflowTemplates => {
      this.workflows = workflowTemplates
    })

    if(this.settingsService.checkIfBetaRoleAccess())
      this.userHasBetaWidgetRole = true

    this.defaultLanguage = this.data.defaultLanguage
    this.formData = deepCopy(this.data.values)
    this.oldData=this.formData
    this.passId = this.data.passId
    this.widgetNumber= this.data.widget

    this.sectionsForm = this.fb.group({})

    if(this.data.translateMode){
      let translateData = this.data.translateData
      const {fields, originalLanguageData, defaultLanguageWidgetData, valuesTranslated, selectedLanguage, values} = translateData

      if(translateData.originalLanguageData){
        this.translationModeOriginal = true
        this.initTranslateEditData( defaultLanguageWidgetData, valuesTranslated, originalLanguageData, [],selectedLanguage)
      }else{
        this.translationModeOriginal = false
        this.initTranslateEditData(values,valuesTranslated, originalLanguageData, fields, selectedLanguage)
      }
    }
    else
    this.initWidgetEdit()

    this.initializePaletteColors()

    this.contextLicenseFree = this.settingsService.contextLicenseFreePublisher$.value

  }

  initTranslateEditData(data, valuesTranslated, originalLanguageData, fields, selectedLanguage){

    let { type, filter,sections, id, title, subtitle,name, submitTitle, widgetStyle,submitAgainTitle, successMessage, workflowTemplateId, submitButtonStyle, reloadDPP} = this.formData
    let {backgroundColor, foregroundColor, borderColor, borderWidth, cornerRadius} = submitButtonStyle ?? {}
    
    if(!originalLanguageData){
      title = valuesTranslated[selectedLanguage + '.' + id + '.title']
      subtitle = valuesTranslated[selectedLanguage + '.' + id + '.subtitle']

      submitTitle = valuesTranslated[selectedLanguage + '.' + id + '.submitTitle']
      submitAgainTitle = valuesTranslated[selectedLanguage +'.' + id + '.submitAgainTitle']
      successMessage = valuesTranslated[selectedLanguage + '.' + id + '.successMessage']
      submitButtonStyle = valuesTranslated[selectedLanguage + '.' + id + '.submitButtonStyle']

      sections?.forEach(section => {
        let section_title = valuesTranslated[selectedLanguage + '.' + id + '_' + section.id + '.title']
        if(section_title)
          section.title = section_title

        section?.fields?.forEach(field => {
          let section_field_title = valuesTranslated[selectedLanguage + '.' + id + '_' + section.id + '_' + field.id + '.title']
          if(section_field_title)
            field.title = section_field_title
          if(field.type === "options"){
            field?.options?.forEach( option => {
              option.title = valuesTranslated[selectedLanguage + '.' + id + '_' + section.id + '_' + field.id +'.options_' + option.id + '.title']
            })
          }
        });

        this.sectionsForm.addControl(section.id+'.fields', new FormControl(section.fields))
        this.sectionsForm.addControl(section.id+'.id', new FormControl(section.id))
        this.sectionsForm.addControl(section.id+'.title', new FormControl(section.title))
      });

    }
    this.sectionsEdit = deepCopy( sections)

    this.formEditForm = this.fb.group({
      type:[{value: type ? type : "form", disabled: checkIfFieldDisabled('type', fields, originalLanguageData)}],
      sections:[{value: sections ? sections : undefined, disabled: checkIfFieldDisabled('sections', fields, originalLanguageData)}],
      id:[{value: id ? id : undefined, disabled: checkIfFieldDisabled('id', fields, originalLanguageData)}],
      title:[{value: title ? title : undefined, disabled: checkIfFieldDisabled('title', fields, originalLanguageData)}],
      subtitle:[{value: subtitle ? subtitle : undefined, disabled: checkIfFieldDisabled('subtitle', fields, originalLanguageData)}],
      name:[{value: name ? name : undefined, disabled: checkIfFieldDisabled('name', fields, originalLanguageData)}],
      reloadDPP:[{value: reloadDPP ? reloadDPP : undefined, disabled: checkIfFieldDisabled('reloadDPP', fields, originalLanguageData)}],
      submitTitle:[{value: submitTitle ? submitTitle : undefined, disabled: checkIfFieldDisabled('submitTitle', fields, originalLanguageData)}],
      submitAgainTitle:[{value: submitAgainTitle ? submitAgainTitle : undefined, disabled: checkIfFieldDisabled('submitAgainTitle', fields, originalLanguageData)}],
      successMessage:[{value: successMessage ? successMessage : undefined, disabled: checkIfFieldDisabled('successMessage', fields, originalLanguageData)}],
      workflowTemplateId: [{value:  workflowTemplateId ? workflowTemplateId : undefined, disabled: checkIfFieldDisabled('workfowTemplateId', fields, originalLanguageData)}],
      submitButtonStyle:[{value: submitButtonStyle ? submitButtonStyle : undefined, disabled: checkIfFieldDisabled('submitButtonStyle', fields, originalLanguageData)}],
      filter:[{value: filter ? filter: undefined, disabled: checkIfFieldDisabled('filter', fields, originalLanguageData)}],
      widgetStyle:[{value: widgetStyle ? widgetStyle : undefined, disabled: checkIfFieldDisabled('widgetStyle', fields, originalLanguageData)}],
      submitButtonStyle_backgroundColor: [{value:backgroundColor ? backgroundColor : this.buttonStyleDefault.backgroundColor, disabled: checkIfFieldDisabled('submitButtonStyle.backgroundColor', fields, originalLanguageData)}, [validColorValidator()]],
      submitButtonStyle_foregroundColor: [{value:foregroundColor ? foregroundColor : this.buttonStyleDefault.foregroundColor, disabled: checkIfFieldDisabled('submitButtonStyle.foregroundColor', fields, originalLanguageData)}, [validColorValidator()]],
      submitButtonStyle_borderColor: [{value: borderColor ? borderColor : this.buttonStyleDefault.borderColor, disabled: checkIfFieldDisabled('submitButtonStyle.borderColor', fields, originalLanguageData)}, [validColorValidator()]],
      submitButtonStyle_borderWidth: [{value: borderWidth ? borderWidth : this.buttonStyleDefault.borderWidth, disabled: checkIfFieldDisabled('submitButtonStyle.borderWidth', fields, originalLanguageData)}],
      submitButtonStyle_cornerRadius: [{value: cornerRadius ? cornerRadius : this.buttonStyleDefault.cornerRadius, disabled: checkIfFieldDisabled('submitButtonStyle.cornerRadius', fields, originalLanguageData)}]
    })

    this.formEditForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe( value => {
      let { type, filter,sections, id, title, subtitle,name, submitTitle, widgetStyle,submitAgainTitle, successMessage, submitButtonStyle} = value

      this.returnChanges.emit({
        type:"form",
        form: this.formEditForm,
        validForm: this.formEditForm.valid,
        translations: {subtitle, title, sections, submitTitle, submitAgainTitle, successMessage},
        saveDisabled: !this.formEditForm.valid
      })
    })

    this.formEditForm.statusChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.formChange.emit(this.formEditForm);
    });

  }

  initWidgetEdit(){

    const { type, filter, sections, id, title, subtitle,name, submitTitle, reloadDPP, widgetStyle, submitAgainTitle, successMessage, workflowTemplateId, submitButtonStyle, value} = this.formData
    let {backgroundColor, foregroundColor, borderColor, borderWidth, cornerRadius} = submitButtonStyle ?? {}

    if(sections){
      sections.forEach((section, sectionIndex) => {
        this.sectionsForm.addControl(section.id+'.fields', new FormControl({value: section.fields, disabled:false}))
        this.sectionsForm.addControl(section.id+'.id', new FormControl({value: section.id, disabled:false}))
        this.sectionsForm.addControl(section.id+'.title', new FormControl({value: section.title, disabled:false}))
        section?.fields?.forEach( field => {
          if(field.type == "options"){
            field.options = field.options?.map( option => {
              if(typeof option === 'string')
                return { id: makeid(3), value: option, title: option} 
              else
                return option
            })
          }
        })
      });
    }
    this.sectionsEdit = deepCopy(sections)

    this.formEditForm = this.fb.group({
      type:[{value: type ? type : "form", disabled:false}],
      sections:[{value: sections ? sections : undefined, disabled:false}],
      id:[{value: id ? id : undefined, disabled:false}],
      title:[{value: title ? title : undefined, disabled:false}],
      subtitle:[{value: subtitle ? subtitle : undefined, disabled:false}],
      name:[{value: name ? name : undefined, disabled:false}],
      submitTitle:[{value: submitTitle ? submitTitle : undefined, disabled:false}],
      submitAgainTitle:[{value: submitAgainTitle ? submitAgainTitle : undefined, disabled:false}],
      successMessage:[{value: successMessage ? successMessage : undefined, disabled:false}],
      workflowTemplateId: [{value:  workflowTemplateId ? workflowTemplateId : undefined, disabled:false}],
      reloadDPP:[{value: reloadDPP ? reloadDPP : undefined, disabled:false}],
      submitButtonStyle:[{value: submitButtonStyle ? submitButtonStyle : undefined, disabled:false}],
      filter:[{value: filter ? filter: undefined, disabled:false}],
      value: [{value: value ? value : undefined, disabled: false}],
      widgetStyle:[{value: widgetStyle ? widgetStyle : undefined, disabled:false}],
      submitButtonStyle_backgroundColor: [{value:backgroundColor ? backgroundColor : this.buttonStyleDefault.backgroundColor, disabled:false}, [validColorValidator()]],
      submitButtonStyle_foregroundColor: [{value:foregroundColor ? foregroundColor : this.buttonStyleDefault.foregroundColor, disabled:false}, [validColorValidator()]],
      submitButtonStyle_borderColor: [{value: borderColor ? borderColor : this.buttonStyleDefault.borderColor, disabled:false}, [validColorValidator()]],
      submitButtonStyle_borderWidth: [{value: borderWidth ? borderWidth : this.buttonStyleDefault.borderWidth, disabled:false}],
      submitButtonStyle_cornerRadius: [{value: cornerRadius ? cornerRadius : this.buttonStyleDefault.cornerRadius, disabled:false}]
    })

    this.formEditForm.valueChanges.subscribe(value => {
      this.checkDuplicatesKeys()
      this.checkInvalidColors()

      this.returnChanges.emit({
        type: this.data.type,
        form: this.formEditForm,
        validForm: this.formEditForm.valid,
        errors: { },
        data: value, //{ form: value, sections: this.sectionsForm.value },
        saveDisabled: this.invalid_backgroundColor || this.invalid_borderColor || this.invalid_foregroundColor || !this.formEditForm.valid 
      })
    })

    this.checkInvalidColors()
  }

  drop(event: CdkDragDrop<string[]>, index:number) {
    moveItemInArray(this.sectionsEdit[index].fields, event.previousIndex, event.currentIndex);
    this.formEditForm.patchValue({sections: this.sectionsEdit})
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  addSection(){
    const newSection = {
      fields:[],
      title: '',
      id: makeid(6)
    }
    this.sectionsEdit.push(newSection)
    this.formEditForm.patchValue({sections: this.sectionsEdit})
  }

  editTitleSection(sectionId, sectionTitle, sectionIndex){
    if(this.data.translateMode && !this.data?.translateData?.originalLanguageData){
      const {valuesTranslated, selectedLanguage} = this.data.translateData
      const widgetId = this.formData.id
      sectionTitle = valuesTranslated[selectedLanguage + '.' + widgetId + '_' + sectionId + '.title']
    }

    if(!this.translationModeOriginal){
      let dialogRef= this.dialog.open(TaskTemplateEditSectionDialogComponent, {
        data: {  values: sectionTitle },
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if(result[1]){
          this.sectionsEdit[sectionIndex].title = result[0].title
          const control = sectionId + '.title'
          this.sectionsForm.patchValue({[control]: result[0].title})
          this.formEditForm.patchValue({sections: this.sectionsEdit})
        }
      });
    }
    
  }

  openFieldDialog(fieldToEdit, fieldNumber,sectionIndex, sectionId){
    if(!this.translationModeOriginal){
      let data = {}
      const widgetId = this.formData.id
      let field = deepCopy( fieldToEdit)
      data = { 
        values: field,
        widgetId: widgetId,
        fieldId: field.id,
        sectionId: sectionId,
        translationMode: this.data.translateMode,
        translateData: this.data.translateData
      }

      if(this.data.translateMode && !this.data.translateData?.originalLanguageData){
        const {valuesTranslated, selectedLanguage} = this.data.translateData

        let fieldTitle = deepCopy(field.title)
        if(!this.translationModeOriginal){
          let title =  valuesTranslated[selectedLanguage +'.'+widgetId+ '_' + sectionId + '_'+ field.id + '.title']
          if(title){
            fieldTitle = title
            field.title = title        
          }

          data = {
            values: deepCopy(field),
            translate: true,
            title: fieldTitle,
            fields: this.data?.translateData?.fields
          }
        }
      }

      let dialogRef = this.dialog.open(FormEditFieldDialogComponent , {
        data
      });
    
      dialogRef.afterClosed().subscribe(result => {
        if(result[1]){
          if(this.data.translateMode){
            const {title, options} = result[0]
            if(title)
            this.sectionsEdit[sectionIndex].fields[fieldNumber].title = title
  
            if(fieldToEdit.type == "options")
            this.sectionsEdit[sectionIndex].fields[fieldNumber].options = options
  
            this.formEditForm.patchValue({sections: this.sectionsEdit})
          }else{
            this.sectionsEdit[sectionIndex].fields[fieldNumber]=result[0]
            this.formEditForm.patchValue({sections: this.sectionsEdit})
          }
          
        }
      });
    }
    
  }

  duplicateSection(section, index){
    const newSection = deepCopy(section)

    if(newSection.fields){
      newSection.fields?.forEach((field, index) => {
        field.id = makeid(6)
        this.allIdsSections.push(field.id)
        field.key += '_copy'
        this.allKeysSection.push(field.key)
      });
    }
    newSection.title += '_copy'
    this.sectionsEdit.push(newSection)
    this.formEditForm.patchValue({sections: this.sectionsEdit})
  }

  deleteSection(sectionTitle, sectionIndex){
    this.sectionsEdit.splice(sectionIndex,1)
    this.formEditForm.patchValue({sections: this.sectionsEdit})
  }

  addFieldToSection(type, sectionIndex){
    const id = makeid(6)
    const _defaultFields = defaultFieldsForm
    if(!this.allIdsSections.includes(id))
      this.allIdsSections.push(id)
    
    const newField = deepCopy(_defaultFields[type])
    newField.id = id
    newField.title += '' + this.addedFields
    newField.key += '' + this.addedFields

    if(this.allKeysSection.includes(newField['key'])){
      const random = makeid(4)
      newField.key += random
      newField.title += random
    }

    this.addedFields++
    this.sectionsEdit[sectionIndex].fields.push(newField)
    this.allKeysSection.push(newField.key)
    this.formEditForm.patchValue({sections: this.sectionsEdit})
  }

  deleteField(field, FieldIndex, sectionIndex){
    this.sectionsEdit[sectionIndex].fields.splice(FieldIndex,1)
    this.formEditForm.patchValue({sections: this.sectionsEdit})
  }


  checkDuplicatesKeys(){
    let allFieldsNumber = 0
    this.allIdsSections=[]
    this.allKeysSection=[]
    let changes = false
    this.duplicateKeys = false

    const registerDuplicatedKey = (field, key = field.key) => {
      this.duplicateKeys = true;
      field.key = `${key}${this.duplicatedKeyNumber}`;
      this.duplicatedKeyNumber++;
      return field.key
      // this.allKeysSection.add(field.key);
    }

    this.sectionsEdit?.forEach((section, index) => {
      section.fields?.forEach( (field, number) => {
        if(field.id){
          if(this.allIdsSections.includes(field.id)){
            field.id = makeid(6)
            changes = true
          }
          this.allIdsSections.push(field.id)
        }
          
        if(field.key){
          allFieldsNumber++
          this.addedFields = allFieldsNumber
          if(this.allKeysSection.includes(field.key)){
            registerDuplicatedKey(field)
            // this.duplicateKeys = true
            // field.key+=this.duplicatedKeyNumber
            // this.duplicatedKeyNumber++
          }
          this.allKeysSection.push(field.key)

        }else{
          if(field.key==""){
            if(this.allKeysSection.includes(field.key)){
              // this.duplicateKeys = true
              // field.key+=this.duplicatedKeyNumber
              // this.duplicatedKeyNumber++
              registerDuplicatedKey(field)
            }
            this.allKeysSection.push("")
          }
        }
      })

      
    });

    if(changes){
      this.formEditForm.patchValue({sections : this.sectionsEdit})
    }
  }

  checkInvalidColors(){
    if(this.formEditForm.controls['submitButtonStyle_backgroundColor'].hasError('invalidColor'))
      this.invalid_backgroundColor=true
    else
      this.invalid_backgroundColor=false
    
    if(this.formEditForm.controls['submitButtonStyle_foregroundColor'].hasError('invalidColor'))
      this.invalid_foregroundColor=true
    else
      this.invalid_foregroundColor=false
    
    if(this.formEditForm.controls['submitButtonStyle_borderColor'].hasError('invalidColor'))
      this.invalid_borderColor=true
    else
      this.invalid_borderColor=false
    
  }

  initializePaletteColors(){
    var colors=[]
    const warmOrange= getComputedStyle(document.documentElement).getPropertyValue('--warmOrange')
    const darkblue= getComputedStyle(document.documentElement).getPropertyValue('--darkBlue')
    const pureWhite= getComputedStyle(document.documentElement).getPropertyValue('--pureWhite')
    const neutral= getComputedStyle(document.documentElement).getPropertyValue('--neutral')
    colors.push(warmOrange)
    colors.push(darkblue)
    colors.push(pureWhite)
    colors.push(neutral)
    this.colorPalette=colors
  }

  returnChangesFilters($event){
    this.formEditForm.patchValue({filter: $event.newFilters})
  }

  returnChangesStyle($event){
    this.formEditForm.patchValue({widgetStyle: $event.newStyle})
  }

}
